import React, { useRef, forwardRef, useState, useEffect } from "react";
import Input from "./Input";
import { drawPicker } from "../popovers/Picker";
import { ENUMS } from "../utils/Enums";
import { ROUTES } from "../utils/Routes";

const Select = forwardRef((props, ref) => {
    const {
        controller = "",
        align = "top",
        top = false,
        offset = [0,10],
        value = props.number ? 0 : "",
        options = [],
        onChange = () => { },
        onSelect = () => { },
        onFocus = () => { },
        onNext = () => { },
        onPrev = () => { },
        placeholder = "",
        width = 200,
        height = 300,
        autocomplete = false,
        title = "Select",
        returnRoute = "",
        ...inputProps
    } = props;

    const none_value = (props.number) ? 0 : ""
    const [opened, setOpened] = useState(false);
    const pendingAction = useRef(null);
    const internalRef = useRef(null); // Internal ref for the Input component

    // Handle both ref objects and functional refs
    useEffect(() => {
        if (typeof ref === "function") {
            // If ref is a function, call it with the internalRef's current value
            ref(internalRef.current);
        } else if (ref && "current" in ref) {
            // If ref is an object, assign the internalRef's current value to it
            ref.current = internalRef.current;
        }
    }, [ref]);


    
    const runAfterClose = (fn) => {
        pendingAction.current = fn;
        setOpened(false);
    };


    // Find matching label to display
    const displayLabel = (() => {
        const opt = options.find((o) =>
            typeof o === "string" ? o === value : o.value === value
        );
        if (!opt) return "";
        return typeof opt === "string" ? opt : opt.label ?? opt.name ?? opt.value;
    })();


    useEffect(() => {
        window.bm_state.value = (opened) ? ROUTES.HELPERS.PICKER : returnRoute;

        if (!opened && pendingAction.current) {
            pendingAction.current();
            pendingAction.current = null;
        }

        
    }, [opened])

    const openSelect = () => {

        if (!internalRef.current) return;
        setOpened(true);
        internalRef.current.blur();

        drawPicker({
            controller : controller,
            top : false,
            showSearch : true,
            noFilter: true,
            align : align,
            mask_close : true,
            closeable: true,
            autocomplete: autocomplete,
            value: value,
            title: title,
            height: height,
            width : width -11,
            ref: internalRef.current,
            route: ROUTES.HELPERS.PICKER,
            offset: offset,
            options,
            close: () => {
                runAfterClose(() => {
                    // onChange(none_value);
                    //onSelect(none_value);
                    //internalRef.current.focus();
                });
            },
            callback: (selected) => {
                runAfterClose(() => {
                    onChange(selected);
                    onSelect(selected);
                    internalRef.current.focus();
                });
            },
            onNext: () => runAfterClose(() => {
                onNext(); 
                
            }),
            onPrev: () => runAfterClose(() => {
                onPrev();
            }),
        });
    };




    return (
        <Input
            // style={{ "pointerEvents": "none" }}
            {...inputProps}
            ref={internalRef} // Use internalRef for the Input component
            value={displayLabel}
            width={width}
            controlled
            placeholder={placeholder}
            onEnter={() => !opened && openSelect()}
            autoselect={false}
            onPageUp={(e) => { if (!opened) { setTimeout(() => {openSelect()}, 10) }  }}
            onFocus={(e) => { onFocus(e); if (!opened) { setTimeout(() => {openSelect()}, 10) } }}
            edit={props.edit}
            opened={opened}
        />
    );
});

export default Select;